import { PipeTransform, Pipe } from "@angular/core";

@Pipe({
  name: 'jsonHTML'
})
export class JsonHTMLPipe implements PipeTransform {
  transform(value: any, args?: string[]): any {
    let strHTML = '';
    if (value && Object.keys(value)) {
      let keys = Object.keys(value);
      let line_prefix = args && args[0] || '<div class="json-list-item">';
      let line_subfix = args && args[1] || '</div>';
      let cap_prefix = args && args[2] || '<strong>- ';
      let cap_subfix = args && args[3] || '</strong>';
      keys.forEach(function(key) {
        strHTML += line_prefix + cap_prefix + key + cap_subfix + ': ' + value[key] + line_subfix;
      });
    }
    return strHTML;
  }
}


// WEBPACK FOOTER //
// ./src/app/pipes/json-html.pipe.ts